module.exports = __webpack_public_path__ + "static/media/simple_progenitor_division.4f50fb45.gif";